export const filterBySearchQuery = (options, searchQuery, searchFields = ['label']) => {
  const searchTerm = searchQuery.trim().toLowerCase();

  if (searchTerm) {
    const isMatched = (label) => label.toLowerCase().includes(searchTerm);
    const isSearchMatched = (item) => searchFields.some((field) => isMatched(item[field] || ''));

    return options.reduce((result, option) => {
      if (isSearchMatched(option)) return [...result, option];
      if (option.children) {
        const matchedChildren = option.children.filter((child) => isSearchMatched(child));
        if (matchedChildren.length) return [...result, { ...option, children: matchedChildren }];
      }

      return result;
    }, []);
  }

  return options;
};
